import axios from "axios"

export const PartsStoreOrdersService = Object.freeze({

  GetBaseUrl(){
    let result = window.appGlobals.API_URL + "PartsStoreOrders/";
    return result;
  },
  OrderHeaderSearch(accountId, userId, OrderHeaderSearchDto) {

    var reqUrl = this.GetBaseUrl() + "SearchOrderHeaders";
    return axios.post(reqUrl, OrderHeaderSearchDto, {
      params: {
        accountId: accountId,
        userId: userId,
      }
    });
  },
  GetOrderCount(PartsStoreOrderCountRequest){

    let reqUrl = this.GetBaseUrl() + "GetOrderCount";
    return axios.post(reqUrl, PartsStoreOrderCountRequest);
  },
  GetOrder(orderId) {

    return axios.get(this.GetBaseUrl() + "GetOrder", {
      params: {
        orderId: orderId
      }
    })
  },
  UpdateOrder(accountId, userId,  OrderDto) {

    return axios.put(this.GetBaseUrl() + "UpdateOrder", OrderDto, {
      params: {
        accountId: accountId,
        userId: userId
      }
    })
  },
  SplitOrderItem(accountId, userId, orderId, orderItemId, dealerNetQuantity, inventoryQuantity){

    return axios.post(this.GetBaseUrl() + "SplitOrderItem", {}, {
      params: {
        accountId: accountId,
        userId: userId,
        orderId: orderId,
        orderItemId: orderItemId,
        dealerNetQuantity: dealerNetQuantity,
        inventoryQuantity: inventoryQuantity
      }
    })
  },
  GetSunbeltOrder(poNumber, customerId){

    return axios.get(this.GetBaseUrl() + "GetSunbeltOrder", {
      params: {
        poNumber: poNumber,
        customerId: customerId
      }
    })
  },
  GetSmartEquipCustomer(customerId){
    return axios.get(this.GetBaseUrl() + "GetSmartEquipCustomer", {
      params: {
        customerId: customerId
      }
    })
  },
  UpdateOrderItem(accountId, userId, orderId, orderItemId, orderItemDto){
    return axios.put(this.GetBaseUrl() + "UpdateOrderItem", orderItemDto, {
      params: {
        accountId: accountId,
        userId: userId,
        orderId: orderId,
        orderItemId: orderItemId
      }
    })
  },
  UpdateOrderItemQuantity(accountId, userId, orderId, orderItemId, quantity){
    return axios.put(this.GetBaseUrl() + "UpdateOrderItemQuantity", quantity, {
      params: {
        accountId: accountId,
        userId: userId,
        orderId: orderId,
        orderItemId: orderItemId,
        quantity: quantity
      }
    })
  },
  ProcessOrder(accountId, userId, orderId, shoppingCartId){
    return axios.put(this.GetBaseUrl() + "ProcessOrder", {}, {
      params: {
        accountId: accountId,
        userId: userId,
        orderId: orderId,
        shoppingCartId: shoppingCartId
      }
    })
  },
  UpdateOrderItemFulfillment(accountId, userId, orderId, orderItemId, fulfillment){
    return axios.put(this.GetBaseUrl() + "UpdateOrderItemFulfillment", {}, {
      params: {
        accountId: accountId,
        userId: userId,
        orderId: orderId,
        orderItemId: orderItemId,
        fulfillment: fulfillment
      }
    })
  },
  UpdateOrderItemFulfillmentOnAllItems(accountId, userId, orderId, fulfillment){
    return axios.put(this.GetBaseUrl() + "UpdateOrderItemFulfillmentOnAllItems", {}, {
      params: {
        accountId: accountId,
        userId: userId,
        orderId: orderId,
        fulfillment: fulfillment
      }
    })
  },
  ProcessOrderAndCleanup(accountId, userId, orderId, shoppingCartId){
    return axios.put(this.GetBaseUrl() + "ProcessOrderAndCleanup", {}, {
      params: {
        accountId: accountId,
        userId: userId,
        orderId: orderId,
        shoppingCartId: shoppingCartId,
      }
    })
  },
  GetShippingOptions(accountId, customerId, showAll, userId ){
    return axios.get(this.GetBaseUrl() + "GetShippingOptions", {
      params: {
        accountId: accountId,
        customerId: customerId,
        showAll: showAll,
        userId: userId,
      }
    })
  },
  GetOrderStatusHistory(accountId, userId, orderId ){
    return axios.get(this.GetBaseUrl() + "GetOrderStatusHistory", {
      params: {
        accountId: accountId,
        userId: userId,
        orderId: orderId
      }
    })
  },
  LinkDealerNetOrder(partsStoreOrderId, dealerNetOrderId, dealerNetOrderNumber, dealerNetOrderSource, dealerCode, salesOrganization){
    return axios.post(this.GetBaseUrl() + "LinkDealerNetOrder", {}, {
      params: {
        partsStoreOrderId: partsStoreOrderId,
        dealerNetOrderId: dealerNetOrderId,
        dealerNetOrderNumber: dealerNetOrderNumber,
        dealerNetOrderSource: dealerNetOrderSource,
        dealerCode: dealerCode,
        salesOrganization: salesOrganization
      }
    })
  }
})
